import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ExternalLinkIcon, MapPinIcon } from 'lucide-react';
const LOCATIONS = [{
  name: 'Clinton',
  url: 'https://preview.4patientcare.com/4755-KU9Z/'
}, {
  name: 'Greenbelt',
  url: 'https://preview.4patientcare.com/4756-BHJA/'
}, {
  name: 'Silver Spring',
  url: 'https://preview.4patientcare.com/4759-TQRJ/'
}, {
  name: 'Mitchellville',
  url: 'https://preview.4patientcare.com/4643-47YE/'
}, {
  name: 'Hyattsville',
  url: 'https://www.myframeboard.com/4757-IDEX'
}, {
  name: 'Frederick',
  url: 'https://www.myframeboard.com/4758-PCLE/'
}];
interface ShopFramesModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ShopFramesModal({
  isOpen,
  onClose
}: ShopFramesModalProps) {
  return <AnimatePresence data-id="element-575">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-576">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-brand-dark/60 backdrop-blur-md" data-id="element-577" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative z-10 bg-white rounded-card shadow-2xl w-full max-w-lg overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-578">
            {/* Header */}
            <div className="bg-brand-dark p-6 text-white relative" data-id="element-579">
              <button onClick={onClose} className="absolute top-4 right-4 z-20 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors focus-ring" aria-label="Close shop frames modal" data-id="element-580">
                <XIcon className="w-5 h-5" data-id="element-581" />
              </button>
              <h2 className="text-2xl font-heading font-bold mb-2 text-[#ec9e04]" data-id="element-582">
                Shop Frames Online
              </h2>
              <p className="text-white/80 text-sm" data-id="element-583">
                Select your preferred location to browse our extensive
                collection of designer frames.
              </p>
            </div>

            {/* Locations List */}
            <div className="p-6 max-h-[60vh] overflow-y-auto" data-id="element-584">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-585">
                {LOCATIONS.map(loc => <a key={loc.name} href={loc.url} target="_blank" rel="noreferrer" className="flex items-center justify-between p-4 rounded-xl border border-gray-200 hover:border-brand-gold hover:bg-brand-gold/5 transition-all group" data-id="element-586">
                    <div className="flex items-center gap-3" data-id="element-587">
                      <div className="bg-gray-100 p-2 rounded-full text-brand-dark group-hover:bg-brand-gold group-hover:text-white transition-colors" data-id="element-588">
                        <MapPinIcon className="w-4 h-4" data-id="element-589" />
                      </div>
                      <span className="font-semibold text-brand-dark text-sm" data-id="element-590">
                        {loc.name}
                      </span>
                    </div>
                    <ExternalLinkIcon className="w-4 h-4 text-neutral-text/40 group-hover:text-brand-gold" data-id="element-591" />
                  </a>)}
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}